import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=2997d8db&"
import script from "./salary.vue?vue&type=script&lang=js&"
export * from "./salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports